import { useEffect, useState } from 'react';

export function useRotatingPlaceholder(placeholders: readonly string[], intervalMs = 4000): string {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (placeholders.length <= 1) return;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % placeholders.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [placeholders, intervalMs]);

  return placeholders.at(index) ?? '';
}
